var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-position": "left",
            "label-width": "80px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Brand" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            disabled: !_vm.isFieldAvailable("brand_id"),
                            placeholder: "Brand",
                            clearable: "",
                          },
                          model: {
                            value: _vm.brandId,
                            callback: function ($$v) {
                              _vm.brandId = $$v
                            },
                            expression: "brandId",
                          },
                        },
                        _vm._l(_vm.brandOptions, function ({ label, value }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: label, value: value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Message", prop: "body" } },
                    [
                      _c("el-input", {
                        ref: "body",
                        staticClass: "message-input",
                        attrs: {
                          disabled: !_vm.isFieldAvailable("body"),
                          type: "textarea",
                          autosize: { minRows: 10, maxRows: 12 },
                          placeholder: "Message",
                        },
                        model: {
                          value: _vm.form.body,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "body", $$v)
                          },
                          expression: "form.body",
                        },
                      }),
                      _vm._v(" "),
                      _c("message-tools", {
                        attrs: { disabled: !_vm.isFieldAvailable("body") },
                        on: { "insert-value": _vm.insertValueIntoMessage },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "start_at" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content:
                                      "Scheduled date and time to begin the campaign",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v("Start "),
                                    _c("i", {
                                      staticClass: "far fa-question-circle",
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("start-input", {
                        attrs: {
                          disabled: !_vm.isFieldAvailable("start_at"),
                          placeholder: "Start",
                        },
                        model: {
                          value: _vm.form.start_at,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "start_at", $$v)
                          },
                          expression: "form.start_at",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "status", label: "Status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: { disabled: !_vm.isFieldAvailable("status") },
                          model: {
                            value: _vm.form.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status",
                          },
                        },
                        _vm._l(_vm.statusOptions, function ({ label, value }) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: label, value: value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "max_messages" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content: "Send Messages Limit",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v("Limit "),
                                    _c("i", {
                                      staticClass: "far fa-question-circle",
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          disabled: !_vm.isFieldAvailable("max_messages"),
                          placeholder: "Send Messages Limit",
                        },
                        model: {
                          value: _vm.form.max_messages,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "max_messages", $$v)
                          },
                          expression: "form.max_messages",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "min_interval" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    content:
                                      "Minimal interval since last contact in days",
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v("Interval "),
                                    _c("i", {
                                      staticClass: "far fa-question-circle",
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c("min-interval-select", {
                        staticClass: "w-100",
                        attrs: {
                          clearable: "",
                          disabled: !_vm.isFieldAvailable("min_interval"),
                          placeholder: "Time since last contact",
                        },
                        model: {
                          value: _vm.form.min_interval,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "min_interval", $$v)
                          },
                          expression: "form.min_interval",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "outgoing_number_id", label: "Sender" } },
                    [
                      _c("outgoing-number-select", {
                        staticClass: "w-100",
                        attrs: {
                          disabled: !_vm.isFieldAvailable("outgoing_number_id"),
                          "brand-id": _vm.brandId,
                          model: _vm.model,
                          url: _vm.searchOutgoingNumbersUrl,
                          placeholder: "Outgoing Number",
                        },
                        model: {
                          value: _vm.form.outgoing_number_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "outgoing_number_id", $$v)
                          },
                          expression: "form.outgoing_number_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "contact_list_id", label: "Recipient" } },
                    [
                      _c("contact-list-select", {
                        staticClass: "w-100",
                        attrs: {
                          disabled: !_vm.isFieldAvailable("contact_list_id"),
                          "brand-id": _vm.brandId,
                          model: _vm.model,
                          url: _vm.searchContactListUrl,
                          placeholder: "Contact List",
                        },
                        model: {
                          value: _vm.form.contact_list_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "contact_list_id", $$v)
                          },
                          expression: "form.contact_list_id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-create px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }